"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateShiftTemplateUpdate = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const error_handler_1 = require("@app/util/error-handler");
const apollo_1 = require("@app/util/apollo");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const util_1 = require("@app/util");
const query = (0, graphql_tag_1.default) `mutation ShiftTemplateUpdateMutation (
  $workspace: ID!,
  $name: String!,
  $data: ShiftData,
  $id: ID!
) {
  shiftTemplateUpdate (
    workspace: $workspace
    name: $name
    id: $id
    data: $data
  ) {
    id
  }
}`;
const mutateShiftTemplateUpdate = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(query, {
        variables
    });
    (0, error_handler_1.processErrors)(errors, (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('SHIFT_TEMPLATE')));
    return data?.shiftTemplateUpdate;
};
exports.mutateShiftTemplateUpdate = mutateShiftTemplateUpdate;
exports.default = exports.mutateShiftTemplateUpdate;
